<template>
	<div class="my-order">
		<el-table ref="afterSaleTable" v-if="!isH5" class="pc-table" :data="tableData"
			style="width: 100%;border-radius: 8px;box-shadow: 0px 3px 16px 0px rgba(0,0,0,0.2);margin-top: 10px;"
			height="70vh">
			<el-table-column :label="$t('商品')" width="380">
				<template slot-scope="scope">
					<div class="commodity">
						<div class="commodity-number">
							{{ scope.row.create_time | onTime(scope.row.create_time) }}
							| {{ $t('订单号：') }}{{ scope.row.aftersale_sn }}
						</div>
						<div class="commodity-message">
							<img :src="scope.row.product_image" alt="" class="commodity-message-img">
							<div class="commodity-message-box">
								<div class="commodity-message-box-tit line2">{{ scope.row.product_title }}</div>
								<div class="commodity-message-box-txt">{{ scope.row.product_sku_text }}</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('退款金额')" width="110">
				<template slot-scope="scope">
					<div class="unitPrice">
						<div class="unitPrice-b">
							￥{{ (scope.row.product_price * scope.row.product_num).toFixed(2) }}
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('申请时间')" width="160">
				<template slot-scope="scope">
					<div class="text-14">
						{{ scope.row.create_time }}
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('售后类型')" width="100">
				<template slot-scope="scope">
					<div class="text-14">
						{{ scope.row.type == 'refund' ? $t('仅退款') : $t('退货退款') }}
					</div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('退款状态')" width="130">
				<template slot-scope="scope">
					<div class="text-14">
						<div v-if="scope.row.type == 'refund'">
							<span v-if="scope.row.aftersale_status == 1">{{ $t('待审核') }}</span>
							<span v-if="scope.row.aftersale_status == 4">{{ $t('退款成功') }}</span>
							<span v-if="scope.row.aftersale_status == -1">{{ $t('拒绝退款') }}</span>
							<span v-if="scope.row.aftersale_status == -2">{{ $t('售后取消') }}</span>
						</div>
						<div v-if="scope.row.type == 'return'">
							<span v-if="scope.row.aftersale_status == 1">{{ $t('待审核') }}</span>
							<span v-if="scope.row.aftersale_status == 2">{{ $t('待寄回') }}</span>
							<span v-if="scope.row.aftersale_status == 3">{{ $t('卖家待收货') }}</span>
							<span v-if="scope.row.aftersale_status == 4">{{ $t('售后已完成') }}</span>
							<span v-if="scope.row.aftersale_status == -1">{{ $t('卖家拒绝退款') }}</span>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="address" :label="$t('操作')" width="120">
				<template slot-scope="scope">
					<div class="btn">
						<div class="btn-61AC85" @click="onRefund(scope.row)">{{ $t('服务详情') }}</div>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<div class="h5-order-list" v-if="isH5">
			<div ref="afterSaleCard" class="h5-order-card" v-for="(row, rIndex) in tableData" :key="rIndex">
				<div class="h5-order-head">
					<span class="h5-order-sn">{{ $t('订单号：') }}{{ row.aftersale_sn }}</span>
					<span class="h5-order-status">{{ aftersaleStatusText(row) }}</span>
				</div>
				<div class="commodity">
					<div class="commodity-message">
						<img :src="row.product_image" alt="" class="commodity-message-img">
						<div class="commodity-message-box">
							<div class="commodity-message-box-tit line2">{{ row.product_title }}</div>
							<div class="commodity-message-box-txt">{{ row.product_sku_text }}</div>
							<div class="h5-order-price">￥{{ (row.product_price * row.product_num).toFixed(2) }}</div>
						</div>
					</div>
				</div>
				<div class="h5-order-foot">
					<div class="h5-order-pay">{{ row.type == 'refund' ? $t('仅退款') : $t('退货退款') }}</div>
					<div class="btn">
						<div class="btn-61AC85" @click="onRefund(row)">{{ $t('服务详情') }}</div>
					</div>
				</div>
			</div>
			<div class="h5-empty" v-if="!tableData.length">{{ $t('暂无数据') }}</div>
		</div>

		<div ref="afterSalePagination" class="order-pagination justify-center">
			<el-pagination layout="prev, pager, next" :page-size="page_size" :total="total" background
				@current-change="onCurrentChange"></el-pagination>
		</div>
	</div>
</template>

<script>
import UserCenterTemp from '@/components/UserCenterTemp'
import { afterSaleList } from '@/api/user';

export default {
	name: 'MyOrder',
	components: {
		'user-center-temp': UserCenterTemp,
	},
	data() {
		return {
			activeIndex: 0,
			typeIndex: 0,
			tableData: [],//订单列表
			page_size: 0,//单页数量
			total: 0,//订单总数
			page: 1,//页数
			isH5: typeof window !== 'undefined' && window.innerWidth < 768,
			// 售后列表入场动画实例，用于组件销毁时释放动画资源
			afterSaleEntranceAnimation: null,
		}
	},
	filters: {
		onTime(value) {
			// 将时间戳转换为日期对象
			let date = new Date(value);
			// 获取年月日
			let year = date.getFullYear();
			let month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1后补零
			let day = String(date.getDate()).padStart(2, '0'); // 日期补零

			let YYYYMMDD = `${year}-${month}-${day}`
			return YYYYMMDD
		}
	},
	mounted() {
		this.updateIsH5();
		window.addEventListener('resize', this.updateIsH5);
		this.onAfterSaleList();
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateIsH5);
		if (this.afterSaleEntranceAnimation) {
			this.afterSaleEntranceAnimation.kill()
		}
	},
	methods: {
		/** 播放售后列表的入场动效 */
		playAfterSaleEntranceAnimation() {
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return
			}
			if (this.afterSaleEntranceAnimation) {
				this.afterSaleEntranceAnimation.kill()
			}
			const listContent = this.isH5
				? (this.$refs.afterSaleCard || [])
				: [this.$refs.afterSaleTable && this.$refs.afterSaleTable.$el]
			const targets = listContent.concat([this.$refs.afterSalePagination]).filter(Boolean)
			this.afterSaleEntranceAnimation = this.$gsap.from(targets, {
				y: 16,
				opacity: 0,
				duration: 0.45,
				stagger: 0.08,
				ease: 'power2.out',
			})
		},
		updateIsH5() {
			this.isH5 = window.innerWidth < 768;
		},
		aftersaleStatusText(row) {
			if (row.type == 'refund') {
				if (row.aftersale_status == 1) return this.$t('待审核');
				if (row.aftersale_status == 4) return this.$t('退款成功');
				if (row.aftersale_status == -1) return this.$t('拒绝退款');
				if (row.aftersale_status == -2) return this.$t('售后取消');
			}
			if (row.type == 'return') {
				if (row.aftersale_status == 1) return this.$t('待审核');
				if (row.aftersale_status == 2) return this.$t('待寄回');
				if (row.aftersale_status == 3) return this.$t('卖家待收货');
				if (row.aftersale_status == 4) return this.$t('售后已完成');
				if (row.aftersale_status == -1) return this.$t('卖家拒绝退款');
			}
			return '';
		},
		onCurrentChange(e) {
			this.page = e;
			this.onAfterSaleList();
		},
		/**售后列表 */
		onAfterSaleList() {
			let obj = {
				page: this.page
			}
			afterSaleList(obj).then(res => {
				// console.log(res.data.data);
				this.page_size = res.data.per_page
				this.total = res.data.total
				let data = res.data.data
				this.tableData = data
				this.$nextTick(() => {
					this.playAfterSaleEntranceAnimation()
				})
			})
		},
		// 订单详情
		onRefund(e) {
			console.log(e);
			// return
			this.$router.push({ name: 'RefundDetail', params: { id: e.id } });
		}
	}
};
</script>

<style scoped lang="scss">
.my-order {
	background: #fff;
	overflow: hidden;
	box-sizing: border-box;
	padding: 0 10px;
}

.orderType {
	padding: 24px;
	display: flex;

	.type_item {
		color: #333;
		font-size: 16px;
		margin-right: 48px;
		cursor: pointer;
	}

	.pitch {
		/* // color: #FD3B00; */
		font-weight: bold;
		padding-bottom: 8px;
		border-bottom: 3px solid #61AC85;
	}

	.num {
		/* // color: #FD3B00; */
	}
}

/*商品*/
.commodity {
	.commodity-number {
		font-size: 14px;
		color: #333333;
		margin-bottom: 8px;
	}

	.commodity-message {
		display: flex;
		align-items: center;

		.commodity-message-img {
			width: 100px;
			height: 100px;
			border-radius: 8px;
			object-fit: cover;
			object-position: center;
			display: block;
		}

		.commodity-message-box {
			margin-left: 16px;
			width: calc(380px - 116px);

			.commodity-message-box-tit {
				font-size: 14px;
				color: #333333;
				margin-bottom: 18px;
				width: 100%;
			}

			.commodity-message-box-txt {
				font-size: 14px;
				color: #999999;
			}
		}
	}
}

/*单价 */
.unitPrice {
	font-size: 14px;

	.unitPrice-t {
		color: #999999;
		text-decoration-line: line-through;
	}

	.unitPrice-b {
		color: #333333;
	}
}

/*按钮 */
.btn {
	div {
		width: 96px;
		height: 32px;
		border-radius: 6px;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin-bottom: 6px;
		cursor: pointer;
	}

	.btn-61AC85 {
		background: #000000;
		color: #FFFFFF;
	}

	.btn-bf {
		background: #cecece;
		color: #333;
	}
}

.h5-order-list {
	display: none;
}

.order-pagination {
	padding-top: 32px;
}

@media (max-width: 767px) {
	.my-order {
		width: 100%;
		max-width: 100%;
		padding: 0;
		overflow: visible;
		background: transparent;
		box-sizing: border-box;
	}

	.h5-order-list {
		display: block;
	}

	.h5-order-card {
		background: #fff;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 12px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
		box-sizing: border-box;
	}

	.h5-order-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		padding-bottom: 10px;
		margin-bottom: 10px;
		border-bottom: 1px solid #eee;
		font-size: 12px;
		color: #999;
	}

	.h5-order-sn {
		flex: 1;
		min-width: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.h5-order-status {
		flex-shrink: 0;
		color: #000;
	}

	.h5-order-card .commodity-message {
		align-items: flex-start;
	}

	.h5-order-card .commodity-message-img {
		width: 72px;
		height: 72px;
		flex-shrink: 0;
	}

	.h5-order-card .commodity-message-box {
		width: calc(100% - 88px);
		min-width: 0;
	}

	.h5-order-card .commodity-message-box-tit {
		margin-bottom: 6px;
	}

	.h5-order-price {
		margin-top: 6px;
		color: #333;
		font-size: 14px;
	}

	.h5-order-foot {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 12px;
		margin-top: 12px;
		border-top: 1px solid #eee;
	}

	.h5-order-pay {
		font-size: 13px;
		color: #666;
	}

	.btn div {
		margin-bottom: 0;
	}

	.h5-empty {
		padding: 48px 0;
		text-align: center;
		color: #999;
		font-size: 14px;
	}

	.order-pagination {
		padding-top: 8px;
		overflow-x: auto;
		display: flex;
		justify-content: center;
		width: 100%;

		/deep/ .el-pagination {
			margin: 0 auto;
			justify-content: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/my/components/AfterSale.vue